import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getOneCMSUrl = (state) => state.getIn(['config', 'oneCMSInternetSSRBaseUrl']);

export const getFullOneCMSUrl = createSelector(
  getOneCMSUrl,
  getActiveLocaleSelector,
  (oneCMSInternetSSRBaseUrl, activeLocale) => `${oneCMSInternetSSRBaseUrl}/Internet/travel/hotel-credit/${activeLocale?.toLowerCase()}/hotel-credit.json`
);
